// NOTE: ALWAYS BE MINDFUL OF THE NEED TO REPLACE SPACES WITH TABS IN SOME FIELDS!!!
export default class SoapDoRefreshTablesCommand {
  constructor() {
    this.tablenames = [];
    this.timestamps = [];
    this.commands = [];
    this.params = [];
    this.types = [];
  }

  addSoapCommandEntry(tablename, timestamp, cmd, param, type) {
    //TODO:  account for TABs if values are ARRAYS
    this.tablenames.push(`<item xsi:type="xsd:string">${tablename}</item>`);

    this.timestamps.push(
      timestamp && timestamp !== null && timestamp !== ""
        ? `<item xsi:type="xsd:string">${timestamp}</item>`
        : `<item xsi:type="xsd:string">00000000000000</item>`
    );

    this.commands.push(`<item xsi:type="xsd:string">${cmd}</item>`);

    this.params.push(
      param && param !== null && param !== ""
        ? `<item xsi:type="xsd:string">${param.replace(/\s+/g, "\t")}</item>`
        : `<item xsi:type="xsd:string"/>`
    );

    this.types.push(
      type && type !== null && type !== ""
        ? `<item xsi:type="xsd:string">${type.replace(/\s+/g, "\t")}</item>`
        : `<item xsi:type="xsd:string"/>`
    );
  }

  generateMessage() {
    return doRefreshTablesTemplate
      .replace("{{tablenameitemscount}}", this.tablenames.length)
      .replace("{{timestampitemscount}}", this.timestamps.length)
      .replace("{{cmditemscount}}", this.commands.length)
      .replace("{{paramitemscount}}", this.params.length)
      .replace("{{ptypeitemscount}}", this.types.length)

      .replace("{{tablenameitems}}", this.tablenames.join(""))
      .replace("{{timestampitems}}", this.timestamps.join(""))
      .replace("{{cmditems}}", this.commands.join(""))
      .replace("{{paramitems}}", this.params.join(""))
      .replace("{{ptypeitems}}", this.types.join(""));
  }

  buildStandardRefreshCommand(
    clientId,
    accountId,
    startYear = null,
    endYear = null
  ) {
    let currentYear = new Date().getFullYear();
    startYear = startYear ?? currentYear - 2;
    endYear = endYear ?? currentYear + 4;

    this.addSoapCommandEntry(
      "tsecurity_rules",
      "00000000000000",
      "select_security_rules",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "thelp_pages",
      "00000000000000",
      "help_select",
      null,
      null
    );
    this.addSoapCommandEntry(
      "tcodes",
      "00000000000000",
      "systemcodes_select",
      null,
      null
    );
    this.addSoapCommandEntry(
      "tclient_defaults",
      "00000000000000",
      "client_defaults_select",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "tclient_extended_attributes",
      "00000000000000",
      "xattributes_select",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "tcompanies",
      "00000000000000",
      "companies_select",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "tcompanyfxhedgetypes",
      "00000000000000",
      "company_fx_hedgetypes_select",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "tcompanyfxinstrtypes",
      "00000000000000",
      "company_fx_instrtypes_select",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "tcountries",
      "00000000000000",
      "select_active_countries",
      `${clientId} Y`,
      `integer string`
    );
    this.addSoapCommandEntry(
      "tcurrencies",
      "00000000000000",
      "select_active_currencies2",
      `${clientId} Y S`,
      `integer string string`
    );
    this.addSoapCommandEntry(
      "tholidays",
      "00000000000000",
      "holidays_select",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "tregions",
      "00000000000000",
      "regions_select",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "tbanks",
      "00000000000000",
      "banks_select2",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "tcontacts",
      "00000000000000",
      "contacts_selectAll2",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "tinstructions",
      "00000000000000",
      "instructions_selectAll3",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "tentities",
      "00000000000000",
      "entities_select_cm",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "tentity_users",
      "00000000000000",
      "entity_users_select",
      `${clientId} ${accountId}`,
      `integer integer`
    );
    this.addSoapCommandEntry(
      "tentity_gl_accounts",
      "00000000000000",
      "entity_glaccounts_select_all",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "tentity_holidays",
      "00000000000000",
      "entityHolidays_select",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "tcurrency_conventions",
      "00000000000000",
      "entity_ctv_select_all",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "taccounts",
      "00000000000000",
      "accounts_select_all7",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "taccount_report_groups",
      "00000000000000",
      "acct_rept_groups_select_all2",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "ttxncode_report_groups",
      "00000000000000",
      "txncode_rept_groups_select_all",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "taccount_services",
      "00000000000000",
      "account_services_select3",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "tcpws_other_accounts",
      "00000000000000",
      "cpos_other_accts_select",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "taccounts",
      "00000000000000",
      "accounts_select_all7",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "tcalendar",
      "00000000000000",
      "calendar_client_select",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "tglaccounts",
      "00000000000000",
      "cm_glaccts3_select",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "ttxntypes",
      "00000000000000",
      "cm_txntypes_select_all",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "ttxncodes",
      "00000000000000",
      "cm_txncodes_select",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "ttxncode_details",
      "00000000000000",
      "cm_txncode_det_select2",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "tfi_mmf_setup",
      "00000000000000",
      "mmf2_setup_select_all2",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "tbdc_bank_holidays",
      "00000000000000",
      "bdc_holidays_select2",
      `${clientId} ${startYear} ${endYear}`,
      `integer integer integer`
    );
    this.addSoapCommandEntry(
      "tcm_fxtrade_purpose",
      "00000000000000",
      "cm_fxtrade_purpose_load_all",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "tfx_docs",
      "00000000000000",
      "cm_fxtrade_docs_load_all_purpose",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "tfxstrategy",
      "00000000000000",
      "fxstrategy_select_all",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "tfi_portfolios",
      "00000000000000",
      "fi_portfolio_insert_all",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "tfi_issuers",
      "00000000000000",
      "fi_issuer_insert_all",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "tfi_instrtypes",
      "00000000000000",
      "fi_InstrTypes_insert_all",
      `${clientId}`,
      `integer`
    );
    this.addSoapCommandEntry(
      "tclients",
      "00000000000000",
      "clients_select_for_master",
      `${accountId}`,
      `integer`
    );
  }
}

const doRefreshTablesHardCodedTemplate = `<?xml version="1.0" encoding="UTF-8"?>
<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:ENC="http://schemas.xmlsoap.org/soap/encoding/" xmlns:tns="http://com.wms.cash" encodingStyle="http://schemas.xmlsoap.org/soap/encoding/">
  <soapenv:Body>
    <tns:doRefreshTables>
      <tableNames xsi:type="ENC:Array" ENC:arrayType="xsd:string[40]">
        <item xsi:type="xsd:string">tsecurity_rules</item>
        <item xsi:type="xsd:string">thelp_pages</item>
        <item xsi:type="xsd:string">tcodes</item>
        <item xsi:type="xsd:string">tclient_defaults</item>
        <item xsi:type="xsd:string">tclient_extended_attributes</item>
        <item xsi:type="xsd:string">tcompanies</item>
        <item xsi:type="xsd:string">tcompanyfxhedgetypes</item>
        <item xsi:type="xsd:string">tcompanyfxinstrtypes</item>
        <item xsi:type="xsd:string">tcountries</item>
        <item xsi:type="xsd:string">tcurrencies</item>
        <item xsi:type="xsd:string">tholidays</item>
        <item xsi:type="xsd:string">tregions</item>
        <item xsi:type="xsd:string">tbanks</item>
        <item xsi:type="xsd:string">tcontacts</item>
        <item xsi:type="xsd:string">tinstructions</item>
        <item xsi:type="xsd:string">tentities</item>
        <item xsi:type="xsd:string">tentity_users</item>
        <item xsi:type="xsd:string">tentity_gl_accounts</item>
        <item xsi:type="xsd:string">tentity_holidays</item>
        <item xsi:type="xsd:string">tcurrency_conventions</item>
        <item xsi:type="xsd:string">taccounts</item>
        <item xsi:type="xsd:string">taccount_report_groups</item>
        <item xsi:type="xsd:string">ttxncode_report_groups</item>
        <item xsi:type="xsd:string">taccount_services</item>
        <item xsi:type="xsd:string">tcpws_other_accounts</item>
        <item xsi:type="xsd:string">taccounts</item>
        <item xsi:type="xsd:string">tcalendar</item>
        <item xsi:type="xsd:string">tglaccounts</item>
        <item xsi:type="xsd:string">ttxntypes</item>
        <item xsi:type="xsd:string">ttxncodes</item>
        <item xsi:type="xsd:string">ttxncode_details</item>
        <item xsi:type="xsd:string">tfi_mmf_setup</item>
        <item xsi:type="xsd:string">tbdc_bank_holidays</item>
        <item xsi:type="xsd:string">tcm_fxtrade_purpose</item>
        <item xsi:type="xsd:string">tfx_docs</item>
        <item xsi:type="xsd:string">tfxstrategy</item>
        <item xsi:type="xsd:string">tfi_portfolios</item>
        <item xsi:type="xsd:string">tfi_issuers</item>
        <item xsi:type="xsd:string">tfi_instrtypes</item>
        <item xsi:type="xsd:string">tclients</item>
      </tableNames>
      <timeStamps xsi:type="ENC:Array" ENC:arrayType="xsd:string[40]">
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
      </timeStamps>
      <cmdName xsi:type="ENC:Array" ENC:arrayType="xsd:string[40]">
        <item xsi:type="xsd:string">select_security_rules</item>
        <item xsi:type="xsd:string">help_select</item>
        <item xsi:type="xsd:string">systemcodes_select</item>
        <item xsi:type="xsd:string">client_defaults_select</item>
        <item xsi:type="xsd:string">xattributes_select</item>
        <item xsi:type="xsd:string">companies_select</item>
        <item xsi:type="xsd:string">company_fx_hedgetypes_select</item>
        <item xsi:type="xsd:string">company_fx_instrtypes_select</item>
        <item xsi:type="xsd:string">select_active_countries</item>
        <item xsi:type="xsd:string">select_active_currencies2</item>
        <item xsi:type="xsd:string">holidays_select</item>
        <item xsi:type="xsd:string">regions_select</item>
        <item xsi:type="xsd:string">banks_select2</item>
        <item xsi:type="xsd:string">contacts_selectAll2</item>
        <item xsi:type="xsd:string">instructions_selectAll3</item>
        <item xsi:type="xsd:string">entities_select_cm</item>
        <item xsi:type="xsd:string">entity_users_select</item>
        <item xsi:type="xsd:string">entity_glaccounts_select_all</item>
        <item xsi:type="xsd:string">entityHolidays_select</item>
        <item xsi:type="xsd:string">entity_ctv_select_all</item>
        <item xsi:type="xsd:string">accounts_select_all7</item>
        <item xsi:type="xsd:string">acct_rept_groups_select_all2</item>
        <item xsi:type="xsd:string">txncode_rept_groups_select_all</item>
        <item xsi:type="xsd:string">account_services_select3</item>
        <item xsi:type="xsd:string">cpos_other_accts_select</item>
        <item xsi:type="xsd:string">accounts_select_all7</item>
        <item xsi:type="xsd:string">calendar_client_select</item>
        <item xsi:type="xsd:string">cm_glaccts3_select</item>
        <item xsi:type="xsd:string">cm_txntypes_select_all</item>
        <item xsi:type="xsd:string">cm_txncodes_select</item>
        <item xsi:type="xsd:string">cm_txncode_det_select2</item>
        <item xsi:type="xsd:string">mmf2_setup_select_all2</item>
        <item xsi:type="xsd:string">bdc_holidays_select2</item>
        <item xsi:type="xsd:string">cm_fxtrade_purpose_load_all</item>
        <item xsi:type="xsd:string">cm_fxtrade_docs_load_all_purpose</item>
        <item xsi:type="xsd:string">fxstrategy_select_all</item>
        <item xsi:type="xsd:string">fi_portfolio_insert_all</item>
        <item xsi:type="xsd:string">fi_issuer_insert_all</item>
        <item xsi:type="xsd:string">fi_InstrTypes_insert_all</item>
        <item xsi:type="xsd:string">clients_select_for_master</item>
      </cmdName>
      <params xsi:type="ENC:Array" ENC:arrayType="xsd:string[40]">
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string"/>
        <item xsi:type="xsd:string"/>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080	Y</item>
        <item xsi:type="xsd:string">12388080	Y	S</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080	1000134</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080	2016	2030</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">1000134</item>
      </params>
      <pTypes xsi:type="ENC:Array" ENC:arrayType="xsd:string[40]">
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string"/>
        <item xsi:type="xsd:string"/>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer	string</item>
        <item xsi:type="xsd:string">integer	string	string</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer	integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer	integer	integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
      </pTypes>
    </tns:doRefreshTables>
  </soapenv:Body>
</soapenv:Envelope>
`;

export const doRefreshTablesTemplateREDUCEDSIZETEST = `<?xml version="1.0" encoding="UTF-8"?>
<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:ENC="http://schemas.xmlsoap.org/soap/encoding/" xmlns:tns="http://com.wms.cash" encodingStyle="http://schemas.xmlsoap.org/soap/encoding/">
  <soapenv:Body>
    <tns:doRefreshTables>
      <tableNames xsi:type="ENC:Array" ENC:arrayType="xsd:string[6]">
        <item xsi:type="xsd:string">tcompanies</item>
        <item xsi:type="xsd:string">tcountries</item>
        <item xsi:type="xsd:string">tbanks</item>
        <item xsi:type="xsd:string">tentities</item>
        <item xsi:type="xsd:string">taccounts</item>
        <item xsi:type="xsd:string">ttxntypes</item>
      </tableNames>
      <timeStamps xsi:type="ENC:Array" ENC:arrayType="xsd:string[6]">
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
        <item xsi:type="xsd:string">00000000000000</item>
      </timeStamps>
      <cmdName xsi:type="ENC:Array" ENC:arrayType="xsd:string[6]">
        <item xsi:type="xsd:string">companies_select</item>
        <item xsi:type="xsd:string">select_active_countries</item>
        <item xsi:type="xsd:string">banks_select2</item>
        <item xsi:type="xsd:string">entities_select_cm</item>
        <item xsi:type="xsd:string">accounts_select_all7</item>
        <item xsi:type="xsd:string">cm_txntypes_select_all</item>
      </cmdName>
      <params xsi:type="ENC:Array" ENC:arrayType="xsd:string[6]">
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080	Y</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
        <item xsi:type="xsd:string">12388080</item>
      </params>
      <pTypes xsi:type="ENC:Array" ENC:arrayType="xsd:string[6]">
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer	string</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
        <item xsi:type="xsd:string">integer</item>
      </pTypes>
    </tns:doRefreshTables>
  </soapenv:Body>
</soapenv:Envelope>
`;

const doRefreshTablesTemplate = `<?xml version="1.0" encoding="UTF-8"?>
<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:ENC="http://schemas.xmlsoap.org/soap/encoding/" xmlns:tns="http://com.wms.cash" encodingStyle="http://schemas.xmlsoap.org/soap/encoding/">
  <soapenv:Body>
    <tns:doRefreshTables>
      <tableNames xsi:type="ENC:Array" ENC:arrayType="xsd:string[{{tablenameitemscount}}]">
        {{tablenameitems}}
      </tableNames>
      <timeStamps xsi:type="ENC:Array" ENC:arrayType="xsd:string[{{timestampitemscount}}]">
        {{timestampitems}}  
      </timeStamps>
      <cmdName xsi:type="ENC:Array" ENC:arrayType="xsd:string[{{cmditemscount}}]">
        {{cmditems}}  
      </cmdName>
      <params xsi:type="ENC:Array" ENC:arrayType="xsd:string[{{paramitemscount}}]">
        {{paramitems}}
      </params>
      <pTypes xsi:type="ENC:Array" ENC:arrayType="xsd:string[{{ptypeitemscount}}]">
        {{ptypeitems}}
      </pTypes>
    </tns:doRefreshTables>
  </soapenv:Body>
</soapenv:Envelope>`;
